window.$ = window.jQuery = $ = jQuery = require("jquery");
require("popper.js");
require("bootstrap");
require("owl.carousel");
require("./smoothscroll");
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

jQuery.fn.mailme = function() {
    var at = / at /;
    var dot = / dot /g;
    this.each( function() {
        var addr = jQuery(this).text().replace(at,"<span>@</span>").replace(dot,".");
        var link = jQuery(this).text().replace(at,"@").replace(dot,".");
        var title = jQuery(this).attr('title')
        $(this)
            .after('<a href="mailto:'+link+'" title="'+title+'">'+ addr +'</a>')
            .remove();
    });
};

$(document).ready(() => {
    $("span.mailme").mailme();

    $('body').on('click', '.nav-toggle', function () {
        $('#main-menu').toggleClass('open');
    });

    if ($("body").hasClass("single-projet")) {
        $('.gallery').owlCarousel({
            items : 1,
            autoHeight: true
        });

        Fancybox.bind("[data-fancybox]");
    }
});